import type { AsyncBelongsTo } from '@ember-data/model';
import { belongsTo } from '@ember-data/model';
import AbstractSignInFieldActionsContactModel from 'garaje/models/abstract/abstract-sign-in-field-actions-contact';
import type GlobalSignInFieldActionRuleGroup from 'garaje/models/global-sign-in-field-action-rule-group';
import adapter from 'garaje/utils/decorators/adapter';

@adapter('sign-in-field-actions-contact')
class GlobalSignInFieldActionsContact extends AbstractSignInFieldActionsContactModel {
  @belongsTo('global-sign-in-field-action-rule-group', { async: true, inverse: 'signInFieldActionsContacts' })
  declare signInFieldActionRuleGroup: AsyncBelongsTo<GlobalSignInFieldActionRuleGroup>;
}

export default GlobalSignInFieldActionsContact;

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'global-sign-in-field-actions-contact': GlobalSignInFieldActionsContact;
  }
}
